<template>
  <div class="g_switch-3">
    <h3 class="tc-b">
      <span class="t_wei">{{title}}</span>
    </h3>
    <div class="g_switch-wrap">
      <ul
        class="s_wrap-list"
        :class="'column-' + columns"
        v-for="(list, index) in calData"
        :key="'list' + index"
      >
        <li class="s_wrap-item" v-for="(item, ind) in list" :key="'item' +ind">
          <g-swtich-item :chip="chip" class="switch-3" :item="item" :type="1" :isSelectAll="isSelectAll" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import GSwtichItem from "../../c_game-switch/switch-item/g_switch-item1";
import Vue from "../../../utils/bus";
// 横向-双行流式排列
export default {
  name: "g_switch-3",
  components: {
    GSwtichItem
  },
  props: {
    chip: String,
    // 列数
    columns: {
      type: Number,
      default: 4
    },

    // 每一对数据 有多少行
    columnNum: {
      type: Number,
      default: 2
    },
    title: {
      type: String,
      default: "title"
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data(){
    return{
       isSelectAll: false
    }
  },
  created() {
    Vue.$on("changSelect", (item) => {
      if (item == this.title || item == "all") {
        if(this.isSelectAll){
          this.isSelectAll=false;
          //Vue.$emit("resetInput");
        }else {
          this.isSelectAll=true;
        }
      }
    });
    Vue.$on("reset",()=>{
      this.isSelectAll=false;
    });
    Vue.$on("resetDefault",()=>{
      this.isSelectAll=false;
    })
  },
  computed: {
    calData() {
      const _arr = this.list.slice();
      const _arr2 = [];

      for (let i = 0; i < this.columns; i++) {
        _arr2[i] = [];
      }

      for (let j = 0; j < _arr.length; j++) {
        _arr2[Math.floor((j / this.columnNum) % this.columns)].push(_arr[j]);
      }

      return _arr2;
    }
  }
};
</script>

<style scoped lang="stylus">
$border-color = #E6E6E6;

.g_switch-3 {
  h3 {
    width: 100%;
    height: 26px;
    border: 1px solid $border-color;
    font-size: 13px;
    box-sizing: border-box;
    text-align: center;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 2px;
    background: linear-gradient(#FEFEFE, #F0F0F0);

    > span {
      display: inline-block;
      position: relative;

      &:before, &:after {
        height: 1px;
        top: 50%;
        display: block;
        content: '';
        position: absolute;
      }

      &:before {
        left: -40px;
      }

      &:after {
        right: -40px;
      }
    }
  }

  .g_switch-wrap {
    display: flex;
    font-size: 13px;
    border-top: 1px solid $border-color;

    .s_wrap-list {
      flex: 1;
      box-sizing: border-box;
      border-right: 1px solid $border-color;
    }

    .s_wrap-list + .s_wrap-list {
      margin-left: 7px;
    }
  }
}

.switch-3 {
  border: 1px solid $border-color;
  border-top: none;
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-list/g_switch-3.vue